
Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Link = {

    answerLinkType: 'answerLinkType',
    questionLinkType: 'questionLinkType',

    createLinkOverlayForAnswer: function (question, answerID, isNew) {

        this.createOverlay();
        this.getQuestions(question.id, question.parentQuestionId);
        this.addButtonGroupListeners(question.id, answerID, this.answerLinkType, isNew);

    },

    createLinkOverlayForQuestion: function (question) {

        this.createOverlay();
        this.getQuestions(question.id, question.parentQuestionId);
        this.addButtonGroupListeners(question.id, null, this.questionLinkType);

    },

    createOverlay: function () {

        var popupElement        = document.querySelector('#Survey'),
            questionFormOverlay = document.createElement('div'),
            questionFormContent = document.createElement('div');

        questionFormOverlay.id = 'SurveyLinkOverlay';
        questionFormContent.id = 'SurveyLinkQuestionForm';
        questionFormContent.appendChild(Greenmile.Survey.Templates.SurveyLinkQuestionTemplate());

        popupElement.appendChild(questionFormOverlay);
        popupElement.appendChild(questionFormContent);

    },

    addButtonGroupListeners: function (questionID, answerID, linkType, isNew) {
        var cancelButton = document.querySelector('#LinkQuestionCancelButton'),
            saveButton   = document.querySelector('#LinkQuestionSaveButton');

        saveButton.addEventListener('click', (function (scope) {
            return function () {
                scope.saveSelection(questionID, answerID, linkType, isNew);
                scope.dismissLinkForm();
            };
        }(this)));

        cancelButton.addEventListener('click', (function (scope) {
            return function () {
                scope.dismissLinkForm();
            };
        }(this)));
    },

    dismissLinkForm: function () {
        var formOverlay   = document.querySelector('#SurveyLinkOverlay'),
            formContent   = document.querySelector('#SurveyLinkQuestionForm'),
            overlayParent = formOverlay.parentNode,
            formParent    = formContent.parentNode;

        overlayParent.removeChild(formOverlay);
        formParent.removeChild(formContent);
    },

    getQuestions: function (questionID, parentQuestionId) {

        var questions = Greenmile.Survey.Data.getAllQuestions(parentQuestionId),
            select    = document.querySelector('#LinkQuestionSelect'),
            option,
            maxLength = 50;

        for (var i = 0; i < questions.length; i++) {

            var value,
                linkQuestionID = questions[i].id,
                canAddQuestion = (!this.hasEqualId(questionID, linkQuestionID) && !this.hasSimpleLoop(questionID, linkQuestionID));

            if (canAddQuestion) {

                value = questions[i].question;

                if (value.length > maxLength) {

                    value = (Greenmile.Survey.Sidebar.answerCropExceedLength([{ value }], maxLength))[0].value + '...';

                }

                option = document.createElement('option');
                option.value = linkQuestionID;
                option.innerHTML = value;
                option.title = questions[i].question;

                select.appendChild(option);

            }

        }

    },

    hasEqualId: function (questionId, linkQuestionId) {

        return (questionId.toString() === linkQuestionId.toString());

    },

    hasSimpleLoop: function (questionId, linkQuestionId) {

        var hasLoop = false;
        var linkedQuestionsLength = Greenmile.Survey.Form.linkedQuestions.length;
        var linkedQuestions = Greenmile.Survey.Form.linkedQuestions;

        for (var j = 0; j < linkedQuestionsLength; j++) {

            var link = linkedQuestions[j];
            var linkedQuestionId = link.questionId.toString();
            var linkedQuestionValue = link.link.value.toString();

            hasLoop = (linkedQuestionId === linkQuestionId.toString() && linkedQuestionValue === questionId.toString());

            if (hasLoop) {

                break;

            }

        }

        return hasLoop;

    },

    saveSelection: function (questionID, answerID, linkType) {

        var select = document.querySelector('#LinkQuestionSelect'),
            option = select.options[select.selectedIndex];

        if (option) {
            Greenmile.Survey.Form.doneLinkingQuestions({
                questionId: questionID,
                answerId: answerID,
                link: {
                    value: option.value,
                    description: option.title
                },
                linkType: linkType
            });
        }

    },

    getNextQuestionByQuestionIdAndAnswerId: function (questionId, answerId) {

        var linkedQuestions = Greenmile.Survey.Form.linkedQuestions;
        var nextQuestion = null;

        for (var i in linkedQuestions) {

            if (parseInt(linkedQuestions[i].questionId) === questionId && linkedQuestions[i].answerId === answerId) {
                nextQuestion = linkedQuestions[i].link.value;
            }

        }

        return nextQuestion;

    },

    clearLinkObjectsForAnswer: function (answerId) {
        const linkedQuestions = Greenmile.Survey.Form.linkedQuestions;

        const linkedQuestionsIndex = linkedQuestions.findIndex(linkedQuestion => linkedQuestion.answerId === answerId);
        const isLinkedQuestionExist = linkedQuestionsIndex !== -1;
        isLinkedQuestionExist && linkedQuestions.splice(linkedQuestionsIndex, 1);
    }
};
